<template>
  <v-card>
    <v-toolbar flat dense color="primary" dark>
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="init" :loading="loading">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <v-toolbar card flat dense color="white">
      <entity-user-list-filter
        v-if="onlyRecordRoles"
        :entityId="entityId"
        :archived="archivedFilters"
        @search="filter"
        @setFilters="setFilters"
        @changeArchivedFilters="onChangeArchivedFilters"
      />
      <v-text-field
        flat
        hide-details
        :placeholder="$t('action.buttons.search')"
        prepend-icon="search"
        solo
        v-model="filters.match"
        @input="search(true)"
      ></v-text-field>

      <template v-if="canManageRole && typeRole !== 'familiar' && !onlyRecordRoles">
        <meta-button
          v-if="can('create', 'user') || hasPermission('CREATE_USER_ACCOUNT_DISABLED')"
          type="new"
          @click="$emit('form', { typeRole })"
        />
      </template>

      <v-menu offset-y origin="center center" :nudge-bottom="10" v-if="!onlyRecordRoles">
        <v-btn icon large flat slot="activator">
          <v-avatar size="30px">
            <v-icon medium>more_vert</v-icon>
          </v-avatar>
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile
            v-if="['coordinator', 'trainer', 'player'].includes(typeRole) && hasPermission('CREATE_USER_ACCOUNT_DISABLED')"
            ripple="ripple"
            @click="$emit('bulkCreate')"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('titles.users.bulkCreate') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            v-if="typeRole === 'player' && hasPermission('CREATE_USER_ACCOUNT_DISABLED')"
            ripple="ripple"
            @click="$emit('import')"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('action.buttons.import') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            ripple="ripple"
            :disabled="!sendRegisterInvitationEnabled"
            @click="sendRegisterInvitation({ typeRole, entityId, teamId, objectId: playerId })"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('action.buttons.sendInvitationToFbase') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-divider></v-divider>

    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="items"
        disable-initial-sort
        :loading="loading || loading"
        :total-items="pagination.totalItems"
        :pagination.sync="pagination"
        :rows-per-page-items="[5, 10]"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center px-0">
            <v-tooltip v-if="props.item.isAccountDisabled" top>
              <template v-slot:activator="{ on }">
                <v-icon
                  @click="sendRegisterInvitation({ _id: props.item._id })"
                  color="success"
                  class="mr-1"
                  v-on="on"
                >mail</v-icon>
              </template>
              <span>{{ $t('action.buttons.sendInvitationToFbase') }}</span>
            </v-tooltip>

            <button-confirm
              color="primary"
              v-if="onlyRecordRoles && props.item.rolesExists && props.item.rolesExists[0] && !props.item.rolesExists[0].isRepeat"
              @submit="confirmRole(props.item, true)"
              small
              flat
              icon="check"
              :text="$t('action.buttons.confirmRole')"
            ></button-confirm>

            <!-- MATITA: solo policy ruoli + perm generale -->
            <v-tooltip
              v-if="can('edit', 'user') && showEdit(props.item)"
              top
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  @click="$emit('form', { id: props.item._id })"
                  color="success"
                  v-on="on"
                >edit</v-icon>
              </template>
              <span>{{ $t('action.buttons.edit') }}</span>
            </v-tooltip>

            <button-confirm
              v-if="onlyRecordRoles && props.item.rolesExists && props.item.rolesExists[0] && !props.item.rolesExists[0].isRepeat"
              color="error"
              small
              flat
              icon="delete"
              :text="$t('action.buttons.rejectRole')"
              @submit="confirmRole(props.item, false)"
            />
            <button-confirm
              v-else
              color="error"
              small
              flat
              icon="delete"
              :text="$t('action.buttons.delete')"
              @submit="deleteUser(props.item)"
            />
          </td>

          <td class="text-xs-center">
            <button-state :state="props.item.active" />
          </td>

          <td class="text-xs-center">
            <v-avatar size="32">
              <img :src="props.item.photo" alt />
            </v-avatar>
          </td>

          <td>{{ props.item.name }} {{ props.item.lastname1 }}</td>

          <td v-if="typeRole === 'familiar'">{{ props.item.telf || '--' }}</td>

          <td v-if="onlyRecordRoles">
            {{ (props.item.recordTeams && props.item.recordTeams[0] && props.item.recordTeams[0].name) || '--' }}
          </td>

          <td v-if="onlyRecordRoles" class="text-xs-center">
            <template v-for="(role, index) in (props.item.recordRole || [])">
              <v-chip :key="index" small color="primary" dark>{{ role }}</v-chip>
            </template>
          </td>

          <td v-if="onlyRecordRoles">
            {{ serializeSubscription(props.item.subscriptions && props.item.subscriptions[0]) }}
          </td>

          <td>{{ props.item.email }}</td>

          <td class="text-xs-center">
            <v-tooltip v-if="props.item.isAccountDisabled" top>
              <template v-slot:activator="{ on }">
                <v-icon
                  @click="sendRegisterInvitation({ _id: props.item._id })"
                  color="success"
                  class="mr-1"
                  v-on="on"
                >mail</v-icon>
              </template>
              <span>{{ $t('action.buttons.sendInvitationToFbase') }}</span>
            </v-tooltip>
            <button-state v-else :state="true" />
          </td>

          <td v-if="typeRole === 'player' && is(['president', 'coordinator'])" class="text-xs-center">
            <button-state :state="!!props.item.isClubPaymentDone" />
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { apiAxios, parseFilters } from '@/helpers'
import { getUserFilters } from '@/helpers/permissions'
import { debounce } from 'debounce'
import { mapActions, mapGetters } from 'vuex'
import EntityUserListFilter from './EntityUserListFilter.vue'

export default {
  name: 'EntityUserList',
  components: { EntityUserListFilter },
  props: {
    entityId: { type: String },
    teamId: { type: String },
    playerId: { type: String },
    typeRole: { type: String },
    title: { type: String },
    reload: { type: [String] },
    onlyRecordRoles: { type: Boolean },
  },
  data() {
    return {
      items: [],
      loading: false,
      filters: { match: '' },
      pagination: {
        hasMore: false,
        page: 1,
        rowsPerPage: 5,
        totalItems: 0,
      },
      team: null,
      archivedFilters: {
        teamId: null,
        recordRoleTypes: [],
      },
      roleList: [
        { name: 'player',      id: '5d2ad31946fbe0ffa8046343' },
        { name: 'familiar',    id: '5d2ad31946fbe0ffa8046345' },
        { name: 'trainer',     id: '5d2ad31946fbe0ffa8046342' },
        { name: 'coordinator', id: '5d2ad31946fbe0ffa8046341' },
        { name: 'president',   id: '5d2ad31946fbe0ffa8046340' },
      ],
    }
  },
  computed: {
    ...mapGetters({ roleSelectList: 'roles/selectListFiltered' }),

    headers() {
      let headers = [
        { text: this.$t('fields.global.actions'), align: 'center', sortable: false },
        { text: this.$t('fields.global.state'), align: 'center', value: 'active' },
        { text: this.$t('fields.users.image'), align: 'center', sortable: false },
        { text: this.$t('fields.global.name'), value: 'name' },
      ]
      if (this.typeRole === 'familiar') {
        headers.push({ text: this.$t('fields.users.phone'), value: 'telf' })
      }
      if (this.onlyRecordRoles) {
        headers.push({ text: this.$tc('models.team', 1), value: 'recordTeams' })
        headers.push({ text: this.$tc('models.role', 2), align: 'center', value: 'recordTeams' })
        headers.push({ text: this.$tc('models.typeSubscription', 1), value: 'subscriptions' })
      }
      headers = [
        ...headers,
        { text: this.$t('fields.users.email'), value: 'email' },
        { text: this.$t('fields.users.registeredUser'), align: 'center', value: 'isAccountDisabled' },
      ]
      if (this.typeRole === 'player' && this.is(['president', 'coordinator'])) {
        headers.push({ text: this.$t('fields.users.isClubPaymentDone'), align: 'center', sortable: false })
      }
      return headers
    },

    canManageRole() {
      if (this.isAdmin) return true
      return this.roleSelectList.some((role) => role.type === this.typeRole)
    },

    sendRegisterInvitationEnabled() {
      return this.items.some((item) => item.isAccountDisabled)
    },
  },
  watch: {
    entityId(val) { if (val) this.init(); else this.clear() },
    teamId() { this.init() },
    reload(val) { if (val == this.typeRole) this.init() },
    'pagination.page'() { this.search() },
    'pagination.rowsPerPage'() { this.search() },
    'pagination.sortBy'() { this.search() },
    'pagination.descending'() { this.search() },
  },
  mounted() { this.init() },
  methods: {
    ...mapActions({
      sendRegisterInvitation: 'users/sendRegisterInvitation',
      enrole: 'users/enrole',
    }),

    // --- HELPERS RUOLO TARGET ---
    _mapRoleTypes(arr) {
      if (!Array.isArray(arr)) return []
      return arr.map(function (r) {
        if (r && r.roleId && r.roleId.type) return r.roleId.type
        if (r && r.type) return r.type
        if (typeof r === 'string') return r
        return null
      }).filter(Boolean)
    },
    _targetRoleTypes(u) {
      if (!u) return []
      if (Array.isArray(u.AllRoles) && u.AllRoles.length) return this._mapRoleTypes(u.AllRoles)
      if (Array.isArray(u.roles) && u.roles.length) return this._mapRoleTypes(u.roles)
      if (Array.isArray(u.rolesExists) && u.rolesExists.length) return this._mapRoleTypes(u.rolesExists)
      if (Array.isArray(u.recordRole) && u.recordRole.length) return this._mapRoleTypes(u.recordRole)
      return []
    },
    _targetHas(u, role) { return this._targetRoleTypes(u).indexOf(role) !== -1 },

    // --- POLICY RUOLI (nessuno scope entity/team) ---
    showEdit(targetUser) {
      // perm generale
      // (manteniamo il check già presente in template ma per sicurezza lo ripetiamo qui)
      if (!(this.can && this.can('edit', 'user'))) return false

      var isAdmin       = !!this.isAdmin
      var isPresident   = this.is ? this.is('president')   : false
      var isCoordinator = this.is ? this.is('coordinator') : false
      var isTrainer     = this.is ? this.is('trainer')     : false

      // Vista 'familiar': admin/president/coordinator/trainer SEMPRE ok
      if (this.typeRole === 'familiar') {
        return (isAdmin || isPresident || isCoordinator || isTrainer)
      }

      if (isAdmin || isPresident) return true

      var targetIsPresident   = this._targetHas(targetUser, 'president')
      var targetIsCoordinator = this._targetHas(targetUser, 'coordinator')

      if (isCoordinator) {
        // può editare tutti tranne presidenti
        return !targetIsPresident
      }

      if (isTrainer) {
        // può editare tutti tranne presidenti e coordinatori
        return !(targetIsPresident || targetIsCoordinator)
      }

      // altri ruoli: no
      return false
    },

    onChangeArchivedFilters(v) {
      this.archivedFilters = { ...this.archivedFilters, ...v }
      this.pagination.page = 1
      this.init()
    },

    async init() {
      const isArchivedView = !!this.onlyRecordRoles
      const isBoss = this.is && this.is(['president', 'coordinator'])

      const params = {
        typeRole: this.typeRole,
        entity: this.entityId,
        team: this.teamId,
        objectId: this.playerId,
        onlyRecordRoles: this.onlyRecordRoles,
      }
      const userScope = isArchivedView && isBoss ? {} : getUserFilters(params)
      let { body, query } = parseFilters(
        {
          filters: this.filters,
          pagination: this.pagination,
          selected: { active: isArchivedView ? 'all' : true },
        },
        params,
        userScope
      )
      if (isArchivedView) {
        body.onlyRecordRoles = true
        if (body.selected) body.selected.active = 'all'
        if (this.archivedFilters.teamId) body.team = this.archivedFilters.teamId
        if (Array.isArray(this.archivedFilters.recordRoleTypes) && this.archivedFilters.recordRoleTypes.length) {
          body.recordRoleTypes = this.archivedFilters.recordRoleTypes
        }
      }
      if (this.entityId && !isArchivedView) delete body.team

      if (this.team) body.team = this.team
      if (this.teamId && this.isTrainer) {
        delete body.entity
        body.team = this.teamId
      }

      this.loading = true
      const { data } = await apiAxios
        .post('users/format', body, { params: { ...query } })
        .finally(() => { this.loading = false })

      this.pagination.totalItems = data.paginate ? data.paginate.totalData : 0
      this.items = data.data ? data.data.users : []
    },

    setFilters(value) {
      this.teamId = value
    },

    async unrole(userId) {
      let payload = { userId, unrole: true, force: true, view: 'player-familiars' }
      switch (this.typeRole) {
        case 'president':
        case 'coordinator':
          payload.userRoleId = this.entityId; break
        case 'trainer':
        case 'player':
          payload.userRoleId = this.teamId; break
        case 'familiar':
          payload.userRoleId = this.playerId; break
        default:
          return
      }
      if (!payload.userRoleId) return
      this.loading = true
      this.enrole(payload).then(() => this.init()).finally(() => { this.loading = false })
    },

    search: debounce(function (resetPage) {
      if (resetPage && this.pagination.page !== 1) this.pagination.page = 1
      this.init()
    }, 1000),

    clear() {
      this.items = []
      this.filters = { match: '' }
      this.pagination = { hasMore: false, page: 1, rowsPerPage: 5, totalItems: 0 }
    },

    serializeSubscription(sub) {
      if (!sub) return '--'
      const isoRaw = (typeof localStorage !== 'undefined' && localStorage.getItem('iso')) || 'en'
      const iso = isoRaw.split('-')[0]
      const names = sub && sub.typeSubscriptionId && sub.typeSubscriptionId.name
        ? sub.typeSubscriptionId.name
        : []
      const tmpName = names.find((name) => (name.iso || '').split('-')[0] === iso)
      return tmpName ? tmpName.text : 'missing translation'
    },

    async confirmRole(item, action) {
      var lastRoleName = null
      if (Array.isArray(item.recordRole) && item.recordRole.length > 0) {
        lastRoleName = item.recordRole[item.recordRole.length - 1]
      }

      const roleDef = this.roleList.find(function(r){ return r.name === lastRoleName })
      const roleId = roleDef ? roleDef.id : null

      const data = {
        roleId: roleId,
        userId: item._id,
        objectId: lastRoleName === 'familiar'
          ? (item.recordPlayers && item.recordPlayers[0] && item.recordPlayers[0]._id)
          : (item.recordTeams && item.recordTeams[0] && item.recordTeams[0]._id),
        assign: action,
      }
      this.loading = true
      apiAxios.post('roles/enrole-record', data)
        .then(() => { this.init(); this.$emit('updateData', lastRoleName) })
        .finally(() => { this.loading = false })
    },

    filter(value) {
      this.team = value
      this.init()
    },

    deleteUser(user) {
      this.loading = true
      apiAxios.post(
        `users/reject_role/${user._id}/${user.AllRoles.find((r) => r.roleId.type === this.typeRole)._id}`,
        { force: true }
      ).then(() => this.init()).finally(() => { this.loading = false })
    },
  },
}
</script>
